interface Props {
  action: string;
  target: { label: string; value: string };
  onConfirm: () => void;
  onCancel: () => void;
}

const ACTION_CONFIGS: Record<string, { title: string; description: string; icon: string; color: string }> = {
  block_ip: {
    title: 'Bloquear IP',
    description: 'Esta IP será agregada a la lista negra y no podrá acceder a ningún servicio de la plataforma.',
    icon: 'ri-forbid-line',
    color: 'bg-red-50 text-red-500',
  },
  unblock_ip: {
    title: 'Desbloquear IP',
    description: 'Esta IP será removida de la lista negra y podrá volver a acceder a la plataforma.',
    icon: 'ri-check-double-line',
    color: 'bg-emerald-50 text-emerald-500',
  },
  block_user: {
    title: 'Bloquear usuario',
    description: 'El usuario será bloqueado y no podrá iniciar sesión. Todas las sesiones activas serán cerradas.',
    icon: 'ri-user-unfollow-line',
    color: 'bg-red-50 text-red-500',
  },
  close_session: {
    title: 'Cerrar sesión',
    description: 'Se cerrará la sesión activa del usuario. Deberá iniciar sesión nuevamente para acceder.',
    icon: 'ri-logout-box-r-line',
    color: 'bg-amber-50 text-amber-500',
  },
  mark_safe: {
    title: 'Marcar como seguro',
    description: 'El evento será marcado como resuelto y no aparecerá en la lista de pendientes.',
    icon: 'ri-shield-check-line',
    color: 'bg-emerald-50 text-emerald-500',
  },
  investigate: {
    title: 'Investigar evento',
    description: 'Se abrirá un caso de investigación para este evento de seguridad.',
    icon: 'ri-search-eye-line',
    color: 'bg-indigo-50 text-indigo-500',
  },
  link_audit: {
    title: 'Ver en Audit Log',
    description: 'Serás redirigido al registro de auditoría correspondiente a este evento.',
    icon: 'ri-external-link-line',
    color: 'bg-accent-50 text-accent-500',
  },
};

export default function SecurityActionModal({ action, target, onConfirm, onCancel }: Props) {
  const config = ACTION_CONFIGS[action];
  if (!config) return null;

  return (
    <>
      <div className="fixed inset-0 z-[100] bg-black/40" onClick={onCancel}></div>
      <div className="fixed inset-0 z-[110] flex items-center justify-center p-4">
        <div className="bg-background-50 border border-background-200 rounded-2xl shadow-xl w-full max-w-sm p-6">
          <div className={`w-12 h-12 rounded-xl flex items-center justify-center mb-4 ${config.color}`}>
            <i className={`${config.icon} text-xl`}></i>
          </div>
          <p className="text-foreground-950 text-sm font-bold mb-1">{config.title}</p>
          <p className="text-foreground-500 text-xs mb-3">{config.description}</p>
          <div className="bg-background-100 rounded-xl p-3 mb-5">
            <p className="text-foreground-400 text-[10px] mb-0.5">{target.label}</p>
            <p className="text-foreground-800 text-xs font-mono font-medium">{target.value}</p>
          </div>
          <div className="flex items-center gap-2">
            <button
              onClick={onCancel}
              className="flex-1 px-4 py-2.5 rounded-xl bg-background-100 text-foreground-600 text-xs font-bold cursor-pointer hover:bg-background-200 transition-colors whitespace-nowrap"
            >
              Cancelar
            </button>
            <button
              onClick={onConfirm}
              className="flex-1 px-4 py-2.5 rounded-xl bg-foreground-950 text-background-50 text-xs font-bold cursor-pointer hover:bg-foreground-800 transition-colors whitespace-nowrap"
            >
              Confirmar
            </button>
          </div>
        </div>
      </div>
    </>
  );
}